import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { WebsocketService } from '../services/v3/websocket.service';

export const SocketInterceptor: HttpInterceptorFn = (req, next) => {
  const socketService = inject(WebsocketService);
  const socketId = socketService.socketId;

  if (socketId) {
    const clonedReq = req.clone({
      setHeaders: {
        'socket-sender-id': String(socketId)
      }
    });
    return next(clonedReq);
  }
  return next(req);
};
